/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Joined_ColInputs */

const en_admin_users_joined_col = /** @type {(inputs: Admin_Users_Joined_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joined`)
};

const zh_admin_users_joined_col = /** @type {(inputs: Admin_Users_Joined_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注册时间`)
};

/**
* | output |
* | --- |
* | "Joined" |
*
* @param {Admin_Users_Joined_ColInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_users_joined_col = /** @type {((inputs?: Admin_Users_Joined_ColInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Joined_ColInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_users_joined_col(inputs)
	return zh_admin_users_joined_col(inputs)
});
export { admin_users_joined_col as "admin.users.joined_col" }